import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import cx from 'classnames';
import s from './EarningSection.css';
import cs from '../../commonStyle.css';

// Translation
import { FormattedMessage } from 'react-intl';
import messages from '../../../locale/messages';

class EarningSection extends Component {
    render() {
        const { data } = this.props;

        return (
            <div className={s.earningSection}>
                <div className={s.container}>
                    <div className={s.earningContent}>
                        <h3 className={s.earningTitle}>{data && data.earningTitle}</h3>
                        <p className={s.earningDesc}>{data && data.earningContent}</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default withStyles(s, cs)(EarningSection); 